module.exports = __webpack_public_path__ + "static/media/type3-hover-5.8a21fe88.jpg";